import { CommonModule } from "@angular/common";
import { Component, inject, input, OnInit, output, signal, TemplateRef, viewChild } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { FormActionButtonsComponent, FormInputComponent } from "../../../shared/components";
import { Constants } from "../../../shared/constants/constants";
import { Language, PageMode } from "../../../shared/constants/enums";
import { ValidatorModelType } from "../../../shared/models";
import { LibTexMapValue } from "../../../shared/models/text-mapping-model";
import { AppService, ValidatorApiService } from "../../../shared/services";

@Component({
  selector: "adaa-text-mapping-value-editor",
  imports: [CommonModule, FormInputComponent, FormActionButtonsComponent, TranslatePipe, ReactiveFormsModule],
  templateUrl: "./text-mapping-value-editor.html",
  styleUrl: "./text-mapping-value-editor.scss",
})
export class TextMappingValueEditorComponent implements OnInit {
  private _formBuilder = inject(FormBuilder);
  private _modalService = inject(NgbModal);
  private _appService = inject(AppService);
  private _toastrService = inject(ToastrService);
  private _translateService = inject(TranslateService);
  private _validatorApiService = inject(ValidatorApiService);

  modal = viewChild.required<TemplateRef<unknown>>("content");

  pageMode = input.required<string>();
  editorClosed = output<LibTexMapValue>();
  PageMode = PageMode;

  textMappingValueForm: FormGroup = new FormGroup({});
  submitted = signal<boolean>(false);
  formValidation = signal<ValidatorModelType | undefined>(undefined);

  public ngOnInit() {
    this._prepareForm();
  }

  private _prepareForm() {
    this.textMappingValueForm = this._formBuilder.group({
      lovTextAE: null,
      lovTextEN: null,
      id: null,
      textMapId: null,
      lovValue: null,
    });

    this._validatorApiService
      .applyValidationToForm(Constants.VALIDATORS_CONF_KEY.VALIDATION_TEXT_MAPPINGS_VALUES, this.textMappingValueForm)
      .subscribe({
        next: (response) => {
          this.formValidation.set(response.validation);
          this.textMappingValueForm = response.form;
        },
      });
  }

  public open() {
    this._modalService.open(this.modal(), {
      animation: true,
      scrollable: false,
      keyboard: false,
      size: "xl",
      centered: true,
      modalDialogClass: this._appService.language() === Language.Arabic ? "modal-rtl" : "modal-ltr",
    });

    this.submitted.set(false);
  }

  public submit() {
    this.submitted.set(true);
    if (this.textMappingValueForm.invalid) {
      this._toastrService.error(this._translateService.instant("common.form.label.missing_information"));
      return;
    }
    const result = {
      ...this.textMappingValueForm.value,
      updateTS: Date.now(),
      status: Constants.OBJECT_STATUS.ACTIVE,
    };

    this.editorClosed.emit(result);
  }

  public checkInvalid(control: string) {
    return (
      this.textMappingValueForm.controls[control].errors?.["required"] &&
      (this.textMappingValueForm.get("nameEN")?.dirty || this.submitted())
    );
  }
}
